import styled from 'styled-components';

export const BannerContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem 1.5rem 0 1.5rem;

  .hefesto-title.hefesto-title--primary h1,
  .hefesto-title.hefesto-title--primary h2 {
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  .hefesto-title.hefesto-title--primary h2 {
    font-size: 2rem;
  }

  .hefesto-button {
    width: 172px !important;
    height: 48px !important;
  }

  p.content {
    color: ${({ theme }) => theme.colors.grayDark4};
    margin-bottom: 0;
  }

  p.content ul {
    padding-left: 1rem;
  }
`;

export const BannerSubtitle = styled.span`
  font-size: 1rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark2};
`;

export const CmsContent = styled.div`
  width: 100%;
  margin-top: 1.5rem;
`;

export const ContentRow = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 1.5rem;
  align-items: center;
`;

export const ImageSide = styled.div`
  & > img {
    width: 466px;
    height: 256px;
    display: block;
    object-fit: cover;
  }
`;

export const TextSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  p.content {
    font-size: 1.25rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;
